module.exports = __webpack_public_path__ + "img/seg1.74bd6f99.svg";